module.exports = __webpack_public_path__ + "img/25.4d5dd0ae.jpg";